export default __webpack_public_path__ + "static/media/uni_black.710d413f.png";